// Resolve the external IDMC "website-components" widget host per environment.
//
// The dashboard/graph widgets (GIDD, IDU, Country Profiles) are served from an
// external bundle whose host differs by environment:
//   - production        -> https://release-website-components.idmcdb.org
//   - UAT / staging      -> https://preview-website-components.idmcdb.org
//   - integration test   -> https://preview-idmc-website-components-3.dev-01.idmcdb.org
//
// It is configured via the build-time env var GATSBY_WEBSITE_COMPONENTS_HOST
// (production is set to the release host in netlify.toml's production context).
// When unset it falls back to the PREVIEW host, so an unconfigured or misconfigured
// build fails toward non-production data rather than pointing staging at production.
const DEFAULT_WIDGET_HOST = "https://preview-website-components.idmcdb.org";

export const getWidgetHost = () => {
  const host = process.env.GATSBY_WEBSITE_COMPONENTS_HOST || DEFAULT_WIDGET_HOST;
  return host.replace(/\/+$/, ""); // strip trailing slashes
};

// Matches any website-components origin, e.g. release-website-components.idmcdb.org
// or the sandbox preview-idmc-website-components-3.dev-01.idmcdb.org.
const WIDGET_HOST_PATTERN =
  /https?:\/\/[a-z0-9.-]*website-components[a-z0-9.-]*\.idmcdb\.org/gi;

// Rewrites any hardcoded website-components origin (e.g. one authored inside a
// Drupal body field for the GIDD/IDU pages) to the configured host, so
// content-authored embeds follow the same per-environment switch as code embeds.
export const rewriteWidgetHost = (url) => {
  if (!url || typeof url !== "string") return url;
  return url.replace(WIDGET_HOST_PATTERN, getWidgetHost());
};
